export default __webpack_public_path__ + "static/4-615833c86e19420b2f4f034d0d80ff2a.webp";